import { useCallback } from "react";
import { useProject, useProjectActions } from "stores/project";

export const useChangeProject = () => {
  const project = useProject();
  const projectActions = useProjectActions();
  const onChange = useCallback(
    (option: { label: string; value: string } | null) => {
      if (!option || project?.id === option.value) {
        return;
      }

      const newUrl = new URL(window.location.href);
      const originalProjectId = newUrl.searchParams.get("originalProjectId");

      if (!originalProjectId) {
        newUrl.searchParams.set("originalProjectId", option.value);
        newUrl.searchParams.set("originalProjectName", option.label);
        window.history.replaceState(null, "", newUrl.toString());
      }

      projectActions.set(option.value);
    },
    [project?.id, projectActions],
  );

  return onChange;
};
